/* ==========================================================================
   POLYMERCRAFTS — CARE INSTRUCTIONS PDP CAROUSEL JS CONTROLLER
   File: assets/care-instructions.js
   Description: Controls smooth touch swipe, mouse drag, scroll snap, 
   and auto-slide behavior for the mobile care instructions card carousel.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initCareInstructionsCarousels();
});

// Shopify Theme Editor Section Load Event Support
document.addEventListener('shopify:section:load', function (event) {
  initCareInstructionsCarousels(event.target);
});

function initCareInstructionsCarousels(scope = document) {
  const careSections = scope.querySelectorAll('.sec__pc-care-instructions');

  careSections.forEach((section) => {
    const track = section.querySelector('.pc-care-track');
    if (!track) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let autoplayTimer = null;

    const enableAutoplay = section.dataset.autoplay === 'true';
    const autoplaySpeed = (parseInt(section.dataset.autoplaySpeed, 10) || 4) * 1000;

    // Mouse Drag Scrolling for Mobile Carousel preview / testing
    track.addEventListener('mousedown', (e) => {
      if (window.innerWidth >= 768) return;
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      stopAutoplay();
    });

    track.addEventListener('mouseleave', () => {
      isDown = false;
      track.classList.remove('is-dragging');
      startAutoplay();
    });

    track.addEventListener('mouseup', () => {
      isDown = false;
      track.classList.remove('is-dragging');
      startAutoplay();
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    });

    // Touch events for mobile hover/pause handling
    track.addEventListener('touchstart', () => {
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', () => {
      startAutoplay();
    }, { passive: true });

    // Hover Pause Handling
    section.addEventListener('mouseenter', () => {
      stopAutoplay();
    });

    section.addEventListener('mouseleave', () => {
      startAutoplay();
    });

    // Auto-Slide Logic for Mobile Carousel
    function startAutoplay() {
      if (!enableAutoplay || window.innerWidth >= 768 || autoplayTimer !== null) return;

      autoplayTimer = setInterval(() => {
        const firstItem = track.querySelector('.pc-care-item');
        if (!firstItem) return;

        const itemWidth = firstItem.offsetWidth + 14;
        const maxScroll = track.scrollWidth - track.clientWidth;

        if (track.scrollLeft + itemWidth >= maxScroll - 10) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: itemWidth, behavior: 'smooth' });
        }
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer !== null) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // Initialize Autoplay on mobile load
    if (enableAutoplay && window.innerWidth < 768) {
      startAutoplay();
    }

    // Resize handler to toggle autoplay timer dynamically
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) {
        stopAutoplay();
      } else if (enableAutoplay && autoplayTimer === null) {
        startAutoplay();
      }
    });
  });
}
